var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ac_delete",
    transform: "translate(-103 -1125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5298",
    "data-name": "Rectangle 5298",
    transform: "translate(103 1125)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ac_delete-2",
    "data-name": "ac_delete",
    d: "M14.714,4a2.916,2.916,0,0,0-2.9,2.9H6.726a.726.726,0,1,0,0,1.452h1.21V20.7A2.665,2.665,0,0,0,10.6,23.364H15.5a6.3,6.3,0,0,1-1.045-1.452H10.6a1.212,1.212,0,0,1-1.21-1.21V8.357h10.65v4.357a6.3,6.3,0,0,1,1.452.175V8.357H22.7a.726.726,0,1,0,0-1.452H17.618A2.916,2.916,0,0,0,14.714,4Zm0,1.452A1.442,1.442,0,0,1,16.166,6.9h-2.9A1.442,1.442,0,0,1,14.714,5.452Zm-1.706,5.315a.726.726,0,0,0-.715.737v7.261a.726.726,0,1,0,1.452,0V11.5a.726.726,0,0,0-.737-.737Zm3.4.01a.726.726,0,0,0-.726.726v2.969a6.3,6.3,0,0,1,1.452-1.045V11.5A.726.726,0,0,0,16.408,10.777Zm3.631,2.9a5.325,5.325,0,1,0,5.325,5.325A5.325,5.325,0,0,0,20.039,13.682Zm-2.42,2.42a.482.482,0,0,1,.342.142l2.078,2.078,2.078-2.078a.484.484,0,0,1,.685.685l-2.078,2.078L22.8,21.085a.484.484,0,1,1-.685.685l-2.078-2.078L17.96,21.769a.484.484,0,0,1-.685-.685l2.078-2.078-2.078-2.078a.484.484,0,0,1,.342-.826Z",
    transform: "translate(99 1123)",
    fill: "#6d809f",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcDelete);
export default __webpack_public_path__ + "static/media/ac_delete.ef75bddb7fdf48c4a7b142cb0dd2222c.svg";
export { ForwardRef as ReactComponent };